module.exports = __webpack_public_path__ + "media/images/refocus_marketing-edfe126ae4c02e303eadf5801c9cc8bf.png";